import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="bg-[#182940] py-16 md:py-20 lg:py-24">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4">
            Ready to Find Your Best Destination?
          </h2>
          <p className="text-base md:text-lg text-white/70 leading-relaxed mb-8">
            Take our free six-question quiz and get a personalised recommendation — along with the key questions to ask any clinic before you commit.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/quiz"
              className="inline-flex items-center justify-center px-6 py-3 text-base font-medium rounded-md bg-primary-500 text-white hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              Take the Free Quiz
              <span className="w-5 h-5 flex items-center justify-center ml-2">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
            <Link
              to="/checklist"
              className="inline-flex items-center justify-center px-6 py-3 text-base font-medium rounded-md border border-white/30 text-white hover:bg-white/5 transition-colors whitespace-nowrap"
            >
              Download the Red Flags Guide
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}